import { HelpCenterMenuItem } from './HelpCenterMenuItem';
import { MewsCommunityMenuItem } from './MewsCommunityMenuItem';
import { MewsUniversityMenuItem } from './MewsUniversityMenuItem';
import { ReleaseNotesMenuItem } from './ReleaseNotesMenuItem';

export const CommonMenuItems = () => (
    <>
        <HelpCenterMenuItem />
        <MewsCommunityMenuItem />
        <MewsUniversityMenuItem />
        <ReleaseNotesMenuItem />
    </>
);
